import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-panfactor',
  templateUrl: './panfactor.component.html',
  styleUrls: ['./panfactor.component.css']
})
export class PanfactorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
